import Lottie from 'lottie-react';
import * as animationData from './spinner.json';

export function Spinner() {
    return <Lottie animationData={animationData} />;
}
